export default {
    UAM_ACTIVATION_TIMEOUT: 180, //activation timeout
    UAM_FIRMWARE_TIMEOUT: 180, //firmware timeout
    UAM_UPDATE_SETTING_TIMEOUT: 60, //update settings timeout
    UAM_CHECK_STATUS_INTERVAL: 2, //check request status and connection status each defined seconds if not connected to WebSocket
    UAM_WAIT_ASSET_TIMEOUT: 10, //wait for assets response after registration
    UAM_DATA_COLLECTION_TIMEOUT: 180, //data collection timeout
    UAM_DATA_COLLECTION_WAIT_FOR_CANCEL_TIMEOUT: 20, //timeout to data collection to be cancelled on dm side. Any uam flow could not be started
    UAM_DATA_COLLECTION_BEFORE_START_TIMEOUT: 10, // wait time after no user action before data collection start
    UAM_WS_RECONNECT_TIMEOUT: 5, //reconnect timeout to WS after connection error
    UAM_WS_PING_INTERVAL: 500, //ws ping interval
    UAM_AUTO_CLEAN_TIMEOUT: 50, //auto clean timeout
    UAM_SYNC_TIMEOUT: 60, //sync timeout
    UAM_USAGE_FLOW_DATA_COLLECTION_INTERVAL: 60, // wait time to refresh device usage data collection
    UAM_ADVANCE_DIAGNOSTIC_WAIT_INFERENCE_COMPLETED_TIMEOUT: 120, // wait for inference_completed event after data collection is received
    UAM_WS_PING_ALIVE_INTERVAL: 2, //ws ping interval to wait pong response
    UAM_WAIT_FETCH_TOKEN_TIMEOUT: 10, //wait for token response
    UAM_ADVANCE_DIAGNOSTIC_FWU_ERROR_REDIRECT_TIMEOUT: 5, //wait for redirect after fwu error
};
